// removed by extract-text-webpack-plugin
module.exports = {"root":"_1h_dR","form":"_3q9yj","forgetPassword":"_2-gwZ","phoneField":"_3Mc6d","divider":"_1sNNt","text":"_2QSOK"};


//////////////////
// WEBPACK FOOTER
// ./app/components/LoginForm/LoginForm.scss
// module id = 1168
// module chunks = 1